import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import { IImportFileTag, IPage } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from './constants';
import formatQueryParams from './formatQueryParams';
import { getRequest } from './requestTypes';

export const getImportFileTags = async (
  params?: DataQueryParams,
): Promise<IPage<IImportFileTag>> =>
  await getRequest(API_BASE_PATHS.METADATA.TAGS, formatQueryParams(params));
